var indentation_default = {
  "indentZero": "MtnLO",
  "indentOne": "e8pCl",
  "indentTwo": "_7HE5I",
  "indentThree": "_4TKh7",
  "indentFour": "qHQe9",
  "indentFive": "IIJ3T",
  "indentSix": "ts-yx"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
